import React from 'react';
import { Link } from 'react-router-dom';

const ForAllPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Сотрудничество для всех</h1>

      <div className="prose max-w-none">
        <p className="mb-6">
        Компания «Теплогранд» приглашает всех заинтересованных лиц и организации к взаимовыгодному партнерству. Мы открыты для сотрудничества в любых форматах и готовы обсудить индивидуальные условия, соответствующие вашим потребностям.        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Преимущества сотрудничества</h2>
        <ul className="list-disc pl-6 mb-6">
          <li>Конкурентные цены на всю продукцию</li>
          <li>Техническая поддержка и консультации</li>
          <li>Оперативная обработка заказов</li>
          <li>Гарантия на все оборудование</li>
          <li>Помощь в подборе оборудования</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Направления сотрудничества</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Розничные продажи</h3>
            <p>Широкий ассортимент оборудования для частных клиентов. Готовые решения по тепло и водоснабжению под ключ.</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Оптовые продажи</h3>
            <p>УСпециальные цены для постоянных покупателей. Рекламно-маркетинговые мероприятия для стимулирования продаж.</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-3">Проектирование</h3>
            <p>Помощь проектировщикам в создании проектов.</p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 mt-8">
          <h2 className="text-2xl font-semibold mb-4">Начать сотрудничество</h2>
          <p className="mb-6">
            Для начала сотрудничества заполните форму обратной связи или свяжитесь с нами любым удобным способом. Наши специалисты ответят на все ваши вопросы и помогут выбрать оптимальный формат взаимодействия.
          </p>
          <Link 
            to="/callback"
            className="bg-primary text-white px-8 py-3 rounded-md hover:bg-primary-dark transition-colors"
          >
            Связаться с нами
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForAllPage; 